import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from 'src/app/services/common/common.service';
import { LoaderService } from 'src/app/services/common/loader.service';
import { PasswordService } from 'src/app/services/general/password-service.service';
import { ShareService } from 'src/app/services/general/share-service.service';
import { NotifyService } from 'src/app/services/notify/notify.service';

@Component({
  selector: 'app-recuperar',
  templateUrl: './recuperar.component.html',
  styleUrls: ['./recuperar.component.css']
})
export class RecuperarComponent implements OnInit {
  public email: string;
  public passwordObj: any = {};
  public newPasswordCopy: string = '';
  public loginData: any;

  constructor(
    public snackBarComponent: MatSnackBar,
    private _notifyService: NotifyService,
    private _loaderService: LoaderService,
    private _passwordService: PasswordService,
    private _share: ShareService,
    private _commonService: CommonService,
    public dialog: MatDialogRef<RecuperarComponent>

  ) { }


  ngOnInit() {
    this.loginData = this._share.getUser();
    this.passwordObj.Email = this.loginData.email;
  }

  submitChangePassword() {
    if (this.passwordObj.NewPassword === this.newPasswordCopy) {
      this._loaderService.display(true);
      this._passwordService.password(this.passwordObj).subscribe(data => {
        if (data.successful) {
          this._notifyService.success('Contraseña cambiada satisfactoriamente.');
        } else {
          this._notifyService.error('El cambio de contraseña no pudo ser completado.');
        }
        this._loaderService.display(false);
      });
    }

  }

  close() {
    this.dialog.close();
  }

}